<template lang="html">
  <div id="d-page-template-1">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Permisos</h2>
        </div>

        <div class="col-sm-6 col-buttons">
          <a class="btn btn-s1 bg-red" @click="$refs['modal-request'].show()">Solicitar Permiso</a>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <h3 class="s-title">Solicitudes</h3>

      <div class="box-results">
        <b-card no-body>
          <b-tabs card>

            <!-- Pendientes -->
            <b-tab title="En espera" active>
              <b-card-text>
                <div class="no-gutters post-template-s4" v-for="(v, vInx) in pendings" :key="'vInx-'+vInx">
                  <div class="col-12 col-title">
                    <h5>Periodo de permiso:</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Comienza</h6>
                    <h5>{{v.start_date}}</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Termina</h6>
                    <h5>{{v.end_date}}</h5>
                  </div>

                  <div class="col-sm col-time col-days">
                    <h6>Día(s)</h6>
                    <h5>{{v.days}}</h5>
                  </div>

                  <div class="col-md col-approval">
                    <h5 class="pending">Pendiente de aprobación</h5>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <!--  -->

            <!-- Autorizados -->
            <b-tab title="Autorizados">
              <b-card-text>
                <div class="no-gutters post-template-s4" v-for="(v, vInx) in authorized" :key="'vInx-'+vInx">
                  <div class="col-12 col-title">
                    <h5>Periodo de permiso:</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Comienza</h6>
                    <h5>{{v.start_date}}</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Termina</h6>
                    <h5>{{v.end_date}}</h5>
                  </div>

                  <div class="col-sm col-time col-days">
                    <h6>Día(s)</h6>
                    <h5>{{v.days}}</h5>
                  </div>

                  <div class="col-md col-approval">
                    <h5 class="">Autorizadas</h5>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <!--  -->
            <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
              <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
              <div v-html="modal.msg"></div>
              
            </sweet-modal>

          </b-tabs>
        </b-card>
      </div>
    </section>

    <b-modal modal-class="modal-request-s1" ref="modal-request" title="Solicitar permiso de ausencia" size="lg" centered hide-footer>
      <b-form @submit.prevent="onSubmitForm($event.target)">
        <b-form-group class="form-group-s1"
          label="Tipo de permiso">
          <b-form-select v-model="formModal.row_type_medicalpermits" required v-bind:class="{ 'untouched' : formModal.tipo == null }">
            <b-form-select-option :value="null">Seleccionar</b-form-select-option>
            <b-form-select-option value="Permiso Medico">Permiso Medico</b-form-select-option>
            <b-form-select-option value="Ausencia">Ausencia</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group  v-slot="{ ariaDescribedby }" class="form-group-s1">
          <b-form-radio v-model="formModal.type" :aria-describedby="ariaDescribedby" name="some-radios" value="Con salario">Con salario</b-form-radio>
          <b-form-radio v-model="formModal.type" :aria-describedby="ariaDescribedby" name="some-radios" value="Sin salario">Sin salario</b-form-radio>
        </b-form-group>

        <b-form-group class="form-group-s1 f-g-timepicker"
          label="Comienza">
          <b-form-datepicker v-model="formModal.start_date" :min="minDate" :date-disabled-fn="dateDisabled" :date-format-options="dateFormOpts" v-bind="datepickerOpts"  placeholder="dd/mm/aaaa" required></b-form-datepicker>
        </b-form-group>

        <b-form-group class="form-group-s1 f-g-timepicker"
          label="Termina">
          <b-form-datepicker v-model="formModal.end_date" :min="minDate" :date-disabled-fn="dateDisabled" :date-format-options="dateFormOpts" v-bind="datepickerOpts"  placeholder="dd/mm/aaaa" required></b-form-datepicker>
        </b-form-group>

        <b-form-group class="form-group-s1"
          label="Describe el motivo de la ausencia">
          <b-form-textarea
            required
            v-model="formModal.comments"
            placeholder="En caso de ser con salario describre la reposicion del tiempo"
            rows="3"
            max-rows="3"
          ></b-form-textarea>
        </b-form-group>

       

        <p class="mb-3">
          <b-form-file plain v-model="formModal.file1" :state="Boolean(formModal.file1)" name="fileone"></b-form-file>
        </p>
        <p class="mb-3">
          <b-form-file plain v-model="formModal.file2" :state="Boolean(formModal.file1)" name="filetwo"></b-form-file>
        </p>
        <p class="mb-3">
          <b-form-file plain v-model="formModal.file3" :state="Boolean(formModal.file1)" name="filethree"></b-form-file>
        </p>

        <b-button type="submit" class="btn-s1 bg-red btn-lg mt-2 w-100">Solicitar</b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },

      formModal: {
        row_type_medicalpermits: null,
        comienza: null,
        termina: null,
        comentarios: null,
        type:null,
      },

      // == Variables para datepicker y timepicker ==
      minDate: null,
      dateFormOpts: { year: 'numeric', month: 'numeric', day: 'numeric' },
      datepickerOpts: {
        labelPrevYear: 'Año anterior',
        labelPrevMonth: 'Mes anterior',
        labelCurrentMonth: 'Mes actual',
        labelNextMonth: 'Mes siguiente',
        labelNextYear: 'Año siguiente',
        labelToday: 'Hoy',
        labelSelected: 'Fecha Seleccionada',
        labelNoDateSelected: 'No seleccionado',
        labelCalendar: 'Calendario',
        labelHelp: 'Use las teclas de movimiento para navegar'
      },
      pendings:[],
      authorized:[],
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
      // == ==
    }
  },

  methods: {
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6
    },

    onSubmit(event) {
      event.preventDefault();
    },

    onSubmitForm(form){	
        
          this.modal.icon = "";
          this.modal.msg = 'Cargando...';
          this.modal.block = true;
          this.$refs.modal.open();

          var data=tools.params(form,this.formModal);
          axios.post(tools.url("/api/medicalpermits"),data).then((response)=>{
              this.$refs['modal-request'].hide();
              this.modal.block = false;
              this.modal.icon = 'success';
              this.modal.msg = 'Información guardada correctamente';
              this.getRows();
          }).catch((error)=>{
              this.modal.block = false;
              this.modal.icon = 'error';
              this.modal.msg = error.response.data.msg;
          });
      },
      getRows(){
        axios.get(tools.url("/api/medicalpermits")).then((response)=>{
            
            this.pendings = response.data.pendings;
            this.authorized = response.data.authorized;
        }).catch(()=>{});
      },
  },

  beforeMount(){
    const now = new Date();
    this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  },

  mounted() {
    this.getRows();
  },
}
</script>
